<template>
    <div class="user-edit">
        <h2 class="page-title">Notification                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    - <span class="fw-semi-bold">Detail</span></h2>
        <Widget :title="(isNew ? 'New' : 'Edit') + ' notification'">
            <Loader v-if="!isNew && isReceiving" :size="40"></Loader>
            <Form v-else>
                <div class="form-group row">
                    <label class="col-md-2" for="message">Message</label>
                    <div class="col-md-5">
                        <input class="form-control" id="message" type="text" :value="notification.message" @change="updateNotificationProperty($event, 'message')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="title">Title</label>
                    <div class="col-md-5">
                        <input class="form-control" id="title" type="text" :value="notification.title" @change="updateNotificationProperty($event, 'title')"/>
                    </div>
                </div>
<!--                <div class="form-group row">-->
<!--                    <label class="col-md-2" for="recurrenceCuantum">Recurrence cuantum</label>-->
<!--                    <div class="col-md-5">-->
<!--                        <input class="form-control" id="recurrenceCuantum" type="number" :value="notification.recurrenceCuantum"-->
<!--                           min="0" @change="updateNotificationProperty($event, 'recurrenceCuantum')"/>-->
<!--                    </div>-->
<!--                </div>-->

                <div class="form-group row" v-if="recurrenceUM != 'Once'">
                    <label class="col-md-2" for="notificationDateRange">Date range</label>
                    <v-date-picker
                        class="col-md-5"
                        mode='range'
                        id="notificationDateRange"
                        v-model='calendarData'
                    />
                </div>

<!--                <div class="form-group row">-->
<!--                    <label class="col-md-2" for="notificationStartDate">Start date</label>-->
<!--                    <DatePicker id="notificationStartDate" lang="en" class="col-md-5"-->
<!--                                v-model="startDate"-->
<!--                                format="DD/MM/YYYY"-->
<!--                                input-class="form-control" @change="selectDate($event, 'startDate')">-->
<!--                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />-->
<!--                    </DatePicker>-->
<!--                </div>-->
<!--                <div class="form-group row">-->
<!--                    <label class="col-md-2" for="notificationEndDate">End date</label>-->
<!--                    <DatePicker id="notificationEndDate" lang="en" class="col-md-5"-->
<!--                                v-model="endDate"-->
<!--                                format="DD/MM/YYYY"-->
<!--                                input-class="form-control" @change="selectDate($event, 'endDate')">-->
<!--                        <i class="glyphicon glyphicon-th" slot="calendar-icon" />-->
<!--                    </DatePicker>-->
<!--                </div>-->
                <div class="form-group row">
                    <label class="col-md-2" for="recurrenceUM">Recurrence UM</label>
                    <v-select class="col-md-5"
                              :clearable="false"
                              id="recurrenceUM"
                              v-model="recurrenceUM"
                              :options="recurrenceUMOptions"
                              @input="onRecurrenceUMSelect"
                    />
                </div>
                <div v-if="recurrenceUM =='Hour'">
                    <div class="form-group row" >
                        <label class="col-md-2" for="hourlyNotification">Run the schedule every</label>
                        <div class="col-md-2 display-flex" style="align-items: center">
                            <input class="form-control" id="hourlyNotification" type="number" :value="notification.hours" @change="updateNotificationProperty($event, 'hours')"/>
                            <span class='pl-3'>hours</span>
                        </div>
                        <div class="col-md-2 display-flex" style="align-items: center">
                            <input class="form-control" id="hourlyNotification1" type="number" :value="notification.minutes" @change="updateNotificationProperty($event, 'minutes')"/>
                            <span class='pl-3'>minutes</span>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-md-2">Start time</label>
                        <vue-timepicker class="col-md-5"
                                        :hour-range=[[7,19]]
                                        v-model="notification.startTime">
                        </vue-timepicker>
                    </div>
                </div>
                <div v-else-if="recurrenceUM =='Day'">
                    <div class="form-group row">
                        <label class="col-md-2">On the following days</label>
                        <div class="col-md-5 display-flex">
                            <div v-for="(day, i) in weekdays" :key="i" class="mr-3" v-if="i<5">
                                <input type="checkbox" v-model="weekdays[i]" />
                                <label>{{weekdayNames[i]}}</label>
                            </div>
<!--                            <div class="mr-3">-->
<!--                                <input type="checkbox" v-model="monday" />-->
<!--                                <label>Mon</label>-->
<!--                            </div>-->
<!--                            <div class="mr-3">-->
<!--                                <input type="checkbox" v-model="tuesday"/>-->
<!--                                <label>Tue</label>-->
<!--                            </div>-->
<!--                            <div class="mr-3">-->
<!--                                <input type="checkbox" v-model="wednesday"/>-->
<!--                                <label>Wed</label>-->
<!--                            </div>-->
<!--                            <div class="mr-3">-->
<!--                                <input type="checkbox" v-model="thursday"/>-->
<!--                                <label>Thu</label>-->
<!--                            </div>-->
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-md-2">Start time</label>
                        <vue-timepicker class="col-md-5"
                                        :hour-range=[[7,19]]
                                        v-model="notification.startTime">
                        </vue-timepicker>
                    </div>
                </div>
                <div v-else-if="recurrenceUM =='Once'">
                    <div class="form-group row">
                        <label class="col-md-2">Start time</label>
<!--                        <vue-timepicker class="col-md-5"-->
<!--                                        id="startTimeOnce"-->
<!--                                        :hour-range=[[9,18]]-->
<!--                                        v-model="notification.startTime">-->
<!--                        </vue-timepicker>-->
                        <datetime class="col-md-5" v-model="notification.startTime"></datetime>

                    </div>
                </div>
                <div class="form-group row" v-if="global == true">
                    <label class="col-md-2" for="timezone">Timezone</label>
                    <div class="col-md-5">
                        <v-select
                            id="timezone"
                            v-model="notification.timezone"
                            :options="getTimezoneOptions()"
                            @input="onTimezoneSelect"
                        />
                    </div>
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                        id="isPublic"
                        :checked="notification.public == true"
                        @change="togglePublic()"
                    />
                    <label for="isPublic">Active</label>
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                           id="isGlobal"
                           :checked="notification.global == true"
                           :disabled="!showGlobalOption()"
                           @change="toggleGlobal()"
                    />
                    <label for="isGlobal">Global</label>
                </div>

                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                           id="sendToAll"
                           :checked="sendToAll"
                           @change="toggleSendToAll()"
                    />
                    <label for="sendToAll">Send to all</label>
                </div>

<!--                {{notification.public}}-->
                <div v-if="sendToAll == false">
                    <div class="form-group mt-4">
                        <label for="notificationUsers">Select users</label>
                        <v-select :clearable="false"
                                  class="w-25"
                                  id="notificationUsers"
                                  :options="availableUsers"
                                  @input="onUserSelect"
                        />

                        <div v-if="selectedUsers.length > 0" class="mt-3"> <b>Selected users</b></div>
                        <div v-for="user in selectedUsers" :key="user.id">
                            <div class="p-2 display-flex w-25" style="justify-content: space-between">
                                <div>
                                    <i class="fa fa-user" />
                                    {{user.firstName}} {{user.lastName}}
                                </div>
                                <i class="fa fa-close ml-4" @click="removeUser(user)"/>

                            </div>

                        </div>
                    </div>
                </div>
                <b-alert class="alert-sm w-25" variant="danger" :show="errorsList.length > 0"
                         v-for="(error, i) in errorsList" :key="i">
                    {{error}}
                </b-alert>
                <b-button-toolbar>
                    <b-button variant="success"
                              @click="saveNotification()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>
                    <span v-if="!isNew">
            <b-button id="deleteNotificationPopover" variant="danger">
              <Loader v-if="isDeleting"></Loader>
              <span v-else>Delete</span>
            </b-button>
            <b-popover class="popover-danger" target="deleteNotificationPopover" placement="top" :show.sync="popover">
              <template slot="title">
                <div class="px-5">Are you sure?</div>
              </template>
              <div class="px-5 d-flex justify-content-center">
                <b-button-toolbar>
                  <b-button variant="success" size="xs" @click="deleteNotification(notification.id)">
                    Yes
                  </b-button>
                  <b-button variant="danger" size="xs" @click="popover = false">
                    No
                  </b-button>
                </b-button-toolbar>
              </div>
            </b-popover>
          </span>
                </b-button-toolbar>
            </Form>
        </Widget>
    </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import DatePicker from 'vue2-datepicker';
  import Vue from "vue";
  import moment from 'moment-timezone';
  import Loader from '../../components/Loader/Loader';
  import vSelect from "vue-select";
  import {firestore} from "../../main";
  import VueTimepicker from 'vue2-timepicker/src'
  import datetime from 'vuejs-datetimepicker';

  export default {
    name: "AddNotification",
    components: { DatePicker, Loader, vSelect, VueTimepicker, datetime },
    data() {
      return {
        recurrenceUM: null,
        sendToAll: true,
        popover: false,
        startDate: null,
        endDate: null,
        global: false,
        availableUsers: [],
        selectedUsers: [],
        recurrenceUMOptions: ['Hour', 'Day', 'Once'],
        errorsList: [],
        weekdays: [false, false, false, false, false, false, false],
        weekdayNames: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        calendarData: {}
      }
    },
    async mounted() {
      if(this.currentUser == undefined){
        await this.fetchCurrentUser();
      }
      if(this.currentUser != undefined){
        const selectedCountryId = this.currentUser.selectedCountryId;
        await this.getNotificationsRequest(selectedCountryId);

        const snapshot = await firestore.collection('users')
          .where("tenantId", "==", selectedCountryId).get()
        this.availableUsers = snapshot.docs.map(doc =>
          Object.assign ({} , doc.data(), {id: doc.id, label: `${doc.data().firstName} ${doc.data().lastName}`}));

        let notification = this.notifications ? this.notifications.find(b => b.id === this.getId()) : null
        if(notification) {
          const userIds = notification.userIds;
          this.selectedUsers = notification.sendToAll ? [] : this.availableUsers.filter(u => userIds.includes(u.id));
          this.availableUsers = notification.sendToAll ? this.availableUsers : this.availableUsers.filter(u => !userIds.includes(u.id));
          this.recurrenceUM = notification.recurrenceUM;
          this.weekdays = notification.weekdays ? notification.weekdays : this.weekdays
          this.global = notification.global

          if(notification.startDate && notification.endDate) {
            const selectedTimezone = notification.global && notification.timezone ? notification.timezone : this.selectedCountry.timezone;

            const s1 = moment.unix(notification.startDate['seconds'])
            const s2 = moment.unix(notification.endDate['seconds'])
            const start = moment.unix(notification.startDate['seconds']).tz(selectedTimezone);
            const end = moment.unix(notification.endDate['seconds']).tz(selectedTimezone);
            this.calendarData = {
                start: new Date(start.year(), start.month(), start.date()),
                end: new Date(end.year(), end.month(), end.date()),
            };
         }
        }
      }
    },
    computed: {
      ...mapState("notifications", ["notifications", "isReceiving", "isUpdating", "isDeleting"]),
      ...mapState("countries", ["selectedCountry"]),
      ...mapState("auth", ["currentUser"]),

      isNew() { return this.getId() === -1},
      notification() {
        return this.findNotification(this.getId()) || {sendToAll: true, recurrenceUM: 'Day'}
      }
    },

    methods: {
      ...mapActions("notifications", ["createNotificationRequest", "updateNotificationRequest", "deleteNotificationRequest",
      "getNotificationsRequest"]),
      ...mapActions("auth", ["fetchCurrentUser"]),
      onSubmit(e) {
        e.preventDefault();
        // !this.isNew() ? this.updateUserRequest({this.user, $toasted}) : this.createUserRequest({this.user, $toaster})
      },
      async saveNotification(){
        let notification = this.notification;
        this.errorsList = [];

        if(notification.message == null || notification.message == ''){
          this.errorsList.push('Message is required!');
        }
        if(notification.title == null || notification.title == ''){
          this.errorsList.push('Title is required!');
        }
        // if(notification.recurrenceCuantum == null || notification.recurrenceCuantum < 1){
        //   this.errorsList.push('Recurrence cuantum is required and must be grater than 1!');
        // }
        if(this.recurrenceUM == null){
          this.errorsList.push('Recurrence UM is required!');
        }
        if(notification.startTime == null || notification.startTime['HH'] == '' || notification.startTime['mm'] == ''){
            this.errorsList.push('Notification start time is required!');
        }
        if(this.recurrenceUM == 'Hour'){
            if(notification.hours == null || notification.hours < 0 || notification.hours > 12){
                this.errorsList.push('Hours is required and must be between 0 and 12!');
            }
            if( notification.minutes == null || notification.minutes < 0 || notification.minutes > 59){
                this.errorsList.push('Minutes is required and must be between 0 and 59!');
            }
        }
        if(this.recurrenceUM == 'Day'){
          if(this.weekdays.filter(a => a).length == 0){
              this.errorsList.push('You have to select at least one day!');
          }
        }

        if(notification.timezone == null && notification.global){
          this.errorsList.push('Timezone is required!');
        }

        const selectedTimezone = notification.global ? notification.timezone : this.selectedCountry.timezone;

        let startDate, endDate = null;
        if(this.recurrenceUM != 'Once' && selectedTimezone != null) {
            startDate = moment(this.calendarData.start, 'DD/MM/YYYY').tz(selectedTimezone, 1);
            endDate = moment(this.calendarData.end, 'DD/MM/YYYY').tz(selectedTimezone, 1);
            if (startDate == null) {
                this.errorsList.push('Start date is required!');
            }
            if (endDate == null) {
                this.errorsList.push('End date is required!');
            }
        }

      if(this.errorsList.length == 0) {
          let finalEndDate = null;
          let finalStartDate = null;
          if(this.recurrenceUM != 'Once') {
              finalStartDate = startDate.set({hour: 0, minute: 0, second: 0}).toDate()
              finalEndDate = endDate.set({hour: 23, minute: 59, second: 59}).toDate()
          }
          let userIds = [];
          if(this.sendToAll == false){
            userIds = this.selectedUsers.map(u => u.id);
          }
          const payload = {
              message: this.notification.message,
              title: this.notification.title,
              // recurrenceCuantum: this.notification.recurrenceCuantum,
              recurrenceUM: this.recurrenceUM,
              public: this.notification.public ? this.notification.public : false,
              global: this.notification.global ? this.notification.global : false,
              sendToAll: this.sendToAll ? this.sendToAll : false,
              startDate: this.recurrenceUM != 'Once' ? finalStartDate : null,
              endDate: this.recurrenceUM != 'Once' ? finalEndDate : null,
              userIds: this.sendToAll ? [] : userIds,
              tenantId: this.selectedCountry.id,
              timezone: this.notification.timezone ? this.notification.timezone : null
          }
          if(this.recurrenceUM == 'Hour'){
              payload.hours = parseInt(notification.hours);
              payload.minutes = parseInt(notification.minutes);
          } else if (this.recurrenceUM == 'Day'){
              payload.weekdays = this.weekdays
          }
          payload.startTime = notification.startTime;
          // payload.startTime = moment(notification.startTime, 'DD/MM/YYYY').tz(this.selectedCountry.timezone, 1).toDate();
          if(this.isNew) {
            await this.createNotificationRequest({
              notification: payload,
              $toasted: this.$toasted
            })
            this.$router.replace('/app/content/notifications');
          } else {
            await this.updateNotificationRequest({
              id: this.notification.id,
              notification: payload,
              $toasted: this.$toasted
            })
            this.$router.replace('/app/content/notifications');

          }
        }
      },
      goBack() {
        this.$router.replace('/app/content/notifications');
      },
      async deleteNotification(id){
        await this.deleteNotificationRequest({id: id, $toasted: this.$toasted});
        this.goBack()
      },
      findNotification(id) {
        let notification = this.notifications ? this.notifications.find(b => b.id === id) : null

        if(notification != null){

            this.sendToAll = notification.sendToAll
        }
        return notification;
      },
      getId() {
        return this.$route.params.id || -1;
      },
      selectDate(val, key) {
        Vue.set(this, key, val);
      },
      updateNotificationProperty(value, key) {
        let notification = this.notification;

        notification[key] = value.target.value;
      },
      togglePublic(){
        let notification = this.notification;
        this.notification.public = (notification.public == null || notification.public == false) ? true : false
        // this.global = this.notification.public
      },
      toggleSendToAll(){
        this.sendToAll = (this.sendToAll == null || this.sendToAll == false) ? true : false
      },
      onUserSelect(user){
        this.selectedUsers.push(user);
        this.availableUsers = this.availableUsers.filter(u => u.id != user.id)
      },
      removeUser(user){
        this.availableUsers.push(user)
        this.selectedUsers = this.selectedUsers.filter(u => u.id != user.id)
      },
      onRecurrenceUMSelect(recurrenceUM){
          this.notification.startTime = null;
      },
      getTimezoneOptions(){
        return moment.tz.names();
      },
      // onTimezoneSelect(selectedTimezone){
      //     debugger;
      //     this.notification.startDate = moment.unix(this.notification.startDate['seconds']).tz(selectedTimezone, 1).set({hour: 0, minute: 0, second: 0}).toDate();
      //     this.notification.endDate = moment.unix(this.notification.endDate['seconds']).tz(selectedTimezone, 1).set({hour: 23, minute: 59, second: 59}).toDate();
      // },
      toggleGlobal(){
        let notification = this.notification;
        notification.global = (notification.global == null || notification.global == false) ? true : false
        this.global = notification.global ;
        this.notification.timezone = null;
      },
      showGlobalOption(){
        if(this.currentUser) {
            const userAuthorities = this.currentUser.userAuthorities;
            const rootAuthority = userAuthorities.filter(a => a.role == 'ROLE_ROOT')
            if (rootAuthority.length > 0) {
                return true;
            }
        }
        return false;
      },
    }
  }
</script>

<style scoped>

</style>
